import ApiError from 'utils/api/errors/ApiError';


class ApiUnauthorizedError extends ApiError {
  constructor (props) {
    super(props);
    this.name = 'ApiUnauthorizedError';
  }
}

export default ApiUnauthorizedError;
